var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h2',{staticClass:"textOne"},[_vm._v(_vm._s(_vm.span))]),_c('h2',{staticClass:"textTwo"},[_vm._v(_vm._s(_vm.h))])])}
var staticRenderFns = []

export { render, staticRenderFns }